import callAPiBase from './base';

const ordersApi = {
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/companyCreateChargeRequest',
      method: 'POST',
      useToken: true,
      title: 'Order - Create',
      data,
    }),
  createOrderSchool: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/schoolCreateChargeRequest',
      method: 'POST',
      useToken: true,
      title: 'Order - Create',
      data,
    }),
  repeat: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/companyRepeatChargeRequest',
      method: 'POST',
      useToken: true,
      title: 'Order - Repeat',
      data,
    }),
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/companyListChargeRequests',
      method: 'GET',
      useToken: true,
      title: 'Orders - Get/List',
      params,
    }),
  list: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/chargeRequestList',
      method: 'GET',
      useToken: true,
      title: 'Orders - Get/List',
      params,
    }),
  getPdf: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/chargeRequestPdf',
      method: 'GET',
      useToken: true,
      title: 'Orders - Get PDF',
      params,
    }),
  payBoleto: ({
    formData,
    transportOperator,
  }: {
    formData: FormData;
    transportOperator: any;
  }) =>
    callAPiBase({
      endpoint: `/chargeRequestPayBoleto?transportOperatorId=${transportOperator}`,
      method: 'POST',
      useToken: true,
      title: 'Order - Pay Boleto',
      formData,
    }),

  chargeRequestPay: ({
    formData,
    chargeRequestId,
  }: {
    formData: FormData;
    chargeRequestId: string;
  }) =>
    callAPiBase({
      endpoint: `/chargeRequestPay?chargeRequestId=${chargeRequestId}`,
      method: 'POST',
      useToken: true,
      title: 'Order - Charge Request Pay',
      formData,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/companyDeleteChargeRequest',
      method: 'DELETE',
      useToken: true,
      title: 'Orders - Delete',
      params,
    }),
};

export { ordersApi };
export default ordersApi;
